import i18n from '@i18n';
import * as yup from 'yup';

export const validationSchema = () =>
  yup.object({
    email: yup
      .string()
      .email(i18n.t('VALIDATION.EMAIL.VALID'))
      .required(i18n.t('VALIDATION.EMAIL.REQUIRED')),
    password: yup
      .string()
      .min(6, i18n.t('VALIDATION.PASSWORD.MIN'))
      .required(i18n.t('VALIDATION.PASSWORD.REQUIRED')),
    first_name: yup.string().required(i18n.t('VALIDATION.NAME.REQUIRED')),
    last_name: yup.string().required(i18n.t('VALIDATION.SURNAME.REQUIRED')),
    phone: yup
      .string()
      .matches(/^(\+|)(\d[0-9]{7,16})$/, i18n.t('VALIDATION.PHONE.FORMAT'))
      .required(i18n.t('VALIDATION.PHONE.REQUIRED')),
    role: yup.string().required(i18n.t('VALIDATION.ROLE.REQUIRED')),
    active: yup.string().required(i18n.t('VALIDATION.REQUIRED')),
  });
